import { IonContent } from '@ionic/react';
import React from 'react';
import styled from 'styled-components';

import { ApiUserType } from '@/modules/api';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import {
  OnboardingPreferencesList,
  OnboardingPreferencesOption,
} from '@/pages/Onboarding/components/PreferencesList';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

export const PreferencesDefaultStyles = styled(OnboardingPage)`
  padding: 0;

  header {
    margin: 40px 0 16px;
  }

  ion-content {
    &::part(scroll) {
      margin-top: 4px;
    }
  }
`;

export const PreferencesVariantDefault: React.FC<{
  preloadCategories: ApiUserType['selected_categories'];
  categories: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
  handleNextStep: () => void;
}> = ({ preloadCategories, categories, form, handleNextStep }) => {
  return (
    <PreferencesDefaultStyles>
      <header>
        <LogoWithAppName />

        <OnboardingTitle color="black">
          Who you want to chat with?
        </OnboardingTitle>
        <OnboardingSubtitle color="neutral-black">
          You can select more than one option:
        </OnboardingSubtitle>
      </header>

      <IonContent>
        <OnboardingPreferencesList>
          {preloadCategories &&
            preloadCategories.map((option) => {
              const active = categories?.includes(option.id);

              return (
                <OnboardingPreferencesOption
                  form={form}
                  active={active}
                  option={option}
                  key={option.id}
                  shape="square"
                />
              );
            })}
        </OnboardingPreferencesList>
      </IonContent>

      <OnboardingFooter
        onContinue={handleNextStep}
        disabled={categories.length === 0}
      />
    </PreferencesDefaultStyles>
  );
};
